import { RulesAndFormOfPaymentComponent } from './../rules-and-form-of-payment/rules-and-form-of-payment.component';
import { LandingpageComponent } from './../landingpage/landingpage.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeEnterpriseComponent } from './home/home-enterprise/home-enterprise.component';
import { AuthGuard } from 'src/app/core/auth/auth.guard';
import { PageNotFoundComponent } from '../page-not-found/page-not-found.component';
import { LoginEnterpriseComponent } from '../login/login-enterprise/login-enterprise.component';
import { HomeComponent } from '../home/home.component';
import { DigitalComponent } from '../digital/digital.component';
import { RegistrationTermsInformationSignComponent } from '../registration-terms-information-sign/registration-terms-information-sign.component';
import { DEFAULT_FULL_PERMISSION_LIST } from 'src/app/core/constants/permission';
import { FirstPageComponent } from "../first-page/first-page.component";
import {RegistrationTermsInformationSignAnonymousComponent} from "../registration-terms-information-sign-anonymous/registration-terms-information-sign-anonymous.component";
import { LoginSsoVneidComponent } from '../login/login-sso-vneid/login-sso-vneid.component';
import { RootEntryGuard } from 'src/app/core/guards/root-entry.guard';

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  // {
  //   path: '',
  //   component: LandingpageComponent,
  //   loadChildren: () => import('../landingpage/landingpag  module').then(d => d.LandingPageModule)
  // },
   {
    path: '',
    pathMatch: 'full',
    canActivate: [RootEntryGuard],
    component: LoginSsoVneidComponent,
  },
  // {
  //   path: '',
  //   component : FirstPageComponent
  // },
  { path: 'rules-and-form-of-payment', component: RulesAndFormOfPaymentComponent },
  { path: 'registration-terms-information-sign', component: RegistrationTermsInformationSignComponent },
  { path: 'registration-terms-information-sign-anonymous', component: RegistrationTermsInformationSignAnonymousComponent },
  {
    path: 'enterprise-login',
    canActivate: [AuthGuard], component: LoginEnterpriseComponent,
    data: {
      defaultPath: 'enterprise-login'
    }
  },
  {
    path: 'home-enterprise',
    component: HomeEnterpriseComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('./home/home-enterprise/home-enterprise.module').then(m => m.HomeEnterpriseModule),
    data: {
      breadcrumb: ['breadcrumbs.home'],
      accessRight: [
        {
          userType: 1,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 2,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 3,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 4,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
        {
          userType: 5,
          permissons: DEFAULT_FULL_PERMISSION_LIST,
          checkParent: false
        },
      ],
      defaultPath: 'home-enterprise'
    }
  },
  {
    path: 'digital',
    component: DigitalComponent,
    loadChildren: () => import('../digital/digital.module').then(d => d.DigitalModule)
  },
  // { path: '', redirectTo: '/home-enterprise/main', pathMatch: 'full' },
  { path: 'page-not-found', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardRoutingModule {
}
